// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"544":"1c16c337","699":"2fb863e4","983":"abf0c27e"}[chunkId] + ".chunk.js";
};